/**
 * Arrow swipers
 *
 * @param $carousel
 */
module.exports = function ($carousel) {
    var navigationSpeed = $carousel.data('options').navigationSpeed;
    $carousel
      .parent()
      .on('click', '.carousel-control.left .icon-prev', function() {
          $carousel.trigger('prev.owl.carousel', [navigationSpeed]);

      })
      .on('click', '.carousel-control.right .icon-next', function() {
          $carousel.trigger('next.owl.carousel', [navigationSpeed]);
      });
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/arrow-swipers.js
// module id = 38
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17